const VoucherPrintType = {
  SELECTED: 1,
  AUTOMATIC: 2
}
export default VoucherPrintType
